import React from 'react';
import Wrap from './Wrap';
import voca from 'voca';
import Typography from '@material-ui/core/Typography';
import Box from '@material-ui/core/Box';
import NextLink from 'next/link';
import Button from '@material-ui/core/Button';
import useStores from '../../../utils/useStores';

const AboutSection = () => {
  const { dataStore } = useStores();
  const page = dataStore.pages.asList.find(
    p => p.uuid === '093e3e56-1529-41f6-a115-231570e683db',
  );

  if (!page) return null;

  const hasData = page.data;
  const abstract = voca.prune(
    hasData &&
      (page.data.abstract || page.data.description || page.data.subtitle),
    400,
    ' ...',
  );

  const linkContext = process.env.NODE_ENV === 'production' ? '/' : '/depv/';

  return (
    <Wrap>
      <Box
        component="img"
        src="/images/DEPV_Logo.svg"
        margin="auto"
        display="block"
        mb={4}
      />
      <Typography color="primary" variant="h2" align="center" gutterBottom>
        {page.title}
      </Typography>
      {abstract && (
        <Box maxWidth={650} margin="auto">
          <Typography variant="h6" align="center">
            {abstract}
          </Typography>
        </Box>
      )}
      <Box textAlign="center" mt={4}>
        <NextLink
          href={`${linkContext}[...pageId]`}
          as={`${linkContext}ueber-den-depv`}
          passHref
        >
          <Button target="_blank" size="large" variant="outlined">
            Mehr über den DEPV
          </Button>
        </NextLink>
      </Box>
    </Wrap>
  );
};

export default AboutSection;
